module.exports = __webpack_public_path__ + "img/logo_klein.0b6cfc32.png";